// options: // [{name:"",value:""}] or [] // value v-model //
<template>
  <div class="MSelect" v-if="isArray">
    <div
      class="input"
      :style="'background:' + bgcolor + ';color:' + currentColor"
      @click="show = !show"
    >
      <div class="title">
        {{ select_index }}
      </div>
      <div class="logo">
        <i class="iconfont icon-xiangxia"></i>
      </div>
    </div>
    <div class="list" v-show="show">
      <ul class="select">
        <li
          @click="optionClick(item, index)"
          class="select-option"
          v-for="(item, index) in options"
          :key="index"
        >
          {{ item }}
        </li>
      </ul>
    </div>
  </div>

  <div class="MSelect" v-else>
    <div
      class="input"
      :style="'background:' + bgcolor + ';color:' + currentColor"
      @click="show = !show"
    >
      <div class="title">
        {{ select_index >= 0 ? options[select_index].name : placeholder }}
      </div>
      <div class="logo">
        <i class="iconfont icon-xiangxia"></i>
      </div>
    </div>
    <div class="list" v-show="show">
      <ul class="select">
        <li
          @click="optionClick(item, index)"
          class="select-option"
          v-for="(item, index) in options"
          :key="index"
        >
          {{ item.name }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "MSelect",
  props: {
    currentColor: {
      type: String,
      default: "#7e7e7e",
    },
    bgcolor: {
      type: String,
      default: "#f9fbff",
    },
    value: {
      type: Number,
      default: -1,
    },
    options: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
  },
  computed: {
    isArray: function () {
      return this.options.length != 0 && typeof this.options[0] == "number";
    },
  },
  data() {
    return {
      show: false,
      select_index: this.value,
    };
  },
  methods: {
    optionClick(item, index) {
      this.select_index = this.isArray ? item : this.options[index].value;
      this.show = false;
      this.$emit("input", Number(this.select_index));
      this.$emit("change", Number(this.select_index));
    },
  },
};
</script>

<style lang="less" scoped>
.MSelect {
  position: relative;
  .input {
    display: flex;
    padding: 0.5rem 1rem;
    border-radius: 10px;
    align-items: center;
    cursor: pointer;
    .title {
      margin: 0 1rem;
    }
    .logo {
      .icon-xiangxia {
        font-weight: 1000;
      }
    }
  }
  .list {
    position: absolute;
    z-index: 10;
    top: 110%;
    border-radius: 8px;
    box-shadow: 2px 2px 4px rgba(23, 28, 39, 0.14);
    text-align: center;
    background: #fff;
    padding: 6px 0;
    width: 100%;
    cursor: pointer;
    .select {
      cursor: pointer;
      list-style: none;
      .select-option {
        margin: 0.1rem;
        border-radius: 6px;
        color: #000;
        opacity: 0.8;
        padding: 0.1rem;
        cursor: pointer;
        &:hover {
          background: #eeeeee;
        }
      }
    }
  }
}
</style>
